/**
 * Formato de dinero del panel de tienda.
 *
 * Los montos se guardan como ENTEROS en la moneda del negocio (no en
 * centavos): `1800` es RD$1,800. Es lo que ya hacía `Product.price` y lo que
 * usa la ficha de despacho.
 */
export function dinero(monto: number | null | undefined, prefijo = 'RD$'): string {
  if (monto == null) return '—';
  return `${prefijo}${monto.toLocaleString('en-US')}`;
}

/**
 * Un número que no se sabe se muestra como «no se sabe», nunca como cero.
 *
 * Es la regla del módulo de finanzas llevada a la pantalla: un costo sin
 * cargar mostrado como RD$0 convierte una pérdida en ganancia a la vista del
 * dueño, y nadie se entera.
 */
export function dineroODesconocido(monto: number | null | undefined, prefijo = 'RD$'): string {
  return monto == null ? 'sin costo cargado' : dinero(monto, prefijo);
}
